import React from "react";
import { isSameColor } from "../../helpers/colors";
import "./LinePalette.sass";

/**
 * The 11 colours of indicator lines and drawings (po-chart-visual-spec.md §7.3),
 * 6 in a row; the current one is ringed.
 *
 * @param {object}   props
 * @param {string[]} props.colors - CSS colours, engine.getLinePalette()
 * @param {string}   props.value - current CSS colour
 * @param {(color: string) => void} props.onChange
 * @param {string}   props.label - accessible name of the group, e.g. "Line color"
 */
const LinePalette = ({ colors, value, onChange, label }) => (
  <div className="line-palette" role="radiogroup" aria-label={label}>
    {colors.map((color) => {
      const isSelected = isSameColor(color, value);

      return (
        <button
          key={color}
          type="button"
          role="radio"
          aria-checked={isSelected}
          aria-label={color}
          title={color}
          className={`line-palette__swatch${isSelected ? " line-palette__swatch--selected" : ""}`}
          style={{ backgroundColor: color }}
          onClick={() => onChange(color)}
        />
      );
    })}
  </div>
);

export default LinePalette;
